// extracted by mini-css-extract-plugin
export default {"container":"ChatTextBox_container__lH3uK","content":"ChatTextBox_content__YEhLU","scrollContainer":"ChatTextBox_scrollContainer__Kz7JK"};